import NotificationText from './NotificationText';
import {props as notificationProps, markRead} from './notification-utils';


export default {
  components: {
    NotificationText
  },

  props: notificationProps,

  methods: {
    relativeURL(href) {
      try {
        const url = new URL(href, location.origin);
        return url.pathname + url.search;

      } catch (error) {
        return null;
      }
    },

    markRead() {
      markRead(this.notification);
    }
  }
};
